import { TRACKER_FILTER_OPTIONS } from "modules/Tracker/constants";
import { userAgentsFields } from "modules/UserAgents/constants";
import { configManagerFields } from "modules/ConfigManager/constants";
import { brandsFields } from "modules/Brands/services/constants";
import { branchesFields } from "modules/Branches/services/constants";
import {collectionStatusFields} from "modules/Metric/services/constants";
import { ITEMS_PER_PAGE, SortOrder } from "constants/general";
import {initialScrapeTaskBatchStartsFields} from "../modules/InitialScrapeTaskBatchStarts/constants";

export const modulesInitialFilters = {
    users: {
        is_deleted: "false",
        offset: "0",
        limit: ITEMS_PER_PAGE
    },
    tracker: {
        sort_field: TRACKER_FILTER_OPTIONS.sort_field,
        sort_direction: TRACKER_FILTER_OPTIONS.sort_direction,
        is_initial: TRACKER_FILTER_OPTIONS.is_initial,
        storage_type_code: "HOT"
    },
    scheduler: {},
    userAgents: {
        sort_field: userAgentsFields.modified,
        sort_direction: SortOrder.desc
    },
    initialScrapeTaskBatchStarts: {
        sort_field: initialScrapeTaskBatchStartsFields.created,
        sort_direction: SortOrder.desc
    },
    objectStructures: {},
    configManager: {
        sort_field: configManagerFields.modified,
        sort_direction: SortOrder.desc
    },
    configCIPublishRequests: {
        sort_field: configManagerFields.created,
        sort_direction: SortOrder.desc,
        status_code: "NEW"
    },
    configCITestTasks: {
        sort_field: configManagerFields.created,
        sort_direction: SortOrder.desc
    },
    credentials: {
        offset: "0",
        limit: "20"
    },
    credentialsTypes: {
        offset: "0",
        limit: "20",
        sort_field: "name",
        sort_direction: SortOrder.asc
    },
    proxyManager: {
        offset: "0",
        limit: "50"
    },
    quotaManager: {
        offset: "0",
        limit: "20"
    },
    primaryKey: {
        offset: "0",
        limit: "50"
    },
    siteGroup: {
        offset: "0",
        limit: "25"
    },
    brands: {
        sort_field: brandsFields.name,
        sort_direction: SortOrder.asc
    },
    brandTrackedDomains: {
        offset: "0",
        limit: "25"
    },
    branches: {
        sort_field: branchesFields.name,
        sort_direction: SortOrder.asc
    },
    collectionStatus: {
        sort_field: collectionStatusFields.branch,
        sort_direction: SortOrder.asc,
        status_change: "BECOME_BROKEN",
        hide_no_data: "true"
    },
    sqsQueues: {
        sort_field: "lag",
        sort_direction: SortOrder.desc,
    },
};
